import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function StarIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'AccentGreen', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 23 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M11.5 15.608L6.865 18l.885-5.065L4 9.348l5.182-.74L11.5 4l2.318 4.609L19 9.348l-3.75 3.587.885 5.065-4.635-2.392z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=Star.js.map